import React, { ReactElement } from "react"
import { ControlProps } from "./__config/shape"
import SelectField from "../SelectField"
import { CanvasType, SpratType } from "../../data/_config/shape"
import { spratTypeOptions } from "./__config/utilities"

/**
 * Select field for the Canvas Type value
 *
 * @export
 * @param {ControlProps<CanvasType>} {
 * 	onChange,
 * 	value,
 * }
 * @returns {ReactElement}
 */
export default React.memo(function SpratTypeSelect({
	onChange,
	value,
}: ControlProps<SpratType>): ReactElement {
	return (
		<SelectField
			name="spratType"
			value={value}
			label="Izaberite sprat"
			onChange={onChange}
			options={spratTypeOptions()}
		/>
	)
})
